<div class="directCallAssistance panel" [class.stickyMode]="stickyMode" [class.withMenu]="withMenu">
  @if (!stickyMode) {
    <div class="close" (click)="closeChat()">
      <label class="close-icon">
        <i class="material-icons notranslate">close</i>
      </label>
    </div>
  }

  <div class="assistances">
    @if (!stickyMode) {
      <h3 class="assistances-title">{{'ASSISTANCES.TOOL_TIP' | translate}}</h3>
    }

    <div class="assistance">
      <div class="visible-info title">
        <div class="name bold">
          <p>{{ 'ASSISTANCES.NEW_ASSISTANCE' | translate }}</p>
          <div class="row-icon add-icon" (click)="startAssistance(!stickyMode)"></div>
        </div>
      </div>
    </div>

  </div>


  @if (userDataService.assetInfo) {
    <div class="allassistances">
      @for (assistance of userDataService.assetInfo.assistances; track assistance) {
        <div class="assistance">
          <div class="visible-info">
            @if (assistance.name) {
              <div class="name">
                <p>{{assistance.name}}</p>
              </div>
            }
            <div class="signin" matTooltip="{{ 'ASSISTANCES.ENTER' | translate }}">
              <img src="/assets/images/buttons/sign-in.svg" (click)="gotoAssistance(assistance.id)" />
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
